import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Asset } from 'src/app/shared/models/asset.model';
import { AppService } from 'src/app/shared/services/app.service';
import { AssetService } from 'src/app/shared/services/asset.service';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-information',
  templateUrl: './product-information.component.html',
  styleUrls: ['./product-information.component.scss']
})
export class ProductInformationComponent implements OnInit {
  public brands: string[] = ["Apple", "Samsung", "Hp", "Lenovo"];
  public serialOrImeiNumber: string = "";
  public selectedBrand: string = "";
  public serialNumber: string;
  public imeiNumber: string;

  constructor(private router: Router, private appService: AppService, public assetService: AssetService, public dialog: MatDialog, private recaptchaV3Service: ReCaptchaV3Service, public translate: TranslateService) { }

  ngOnInit(): void {
    this.appService.setProgress("0");
    this.appService.setAsset(new Asset());
    this.assetService.setImei(false);
    this.assetService.setSerial(false);
    
  }

  public openInfoDialog() {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: "350px"
    });
  }

  public onSubmit() {
    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: string) => {
      console.debug(`Token [${token}] generated`);

      if (token) {
       if(this.serialNumber){
         this.serialOrImeiNumber = this.serialNumber;
         this.assetService.setSerial(true);
         this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
          if(data != null){
            this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
          } else if(this.imeiNumber){
            this.serialOrImeiNumber = this.imeiNumber;
            this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
              if(data != null){
                this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
              } else{
                this.router.navigate(["/description/"+ this.serialOrImeiNumber], { queryParams: {type: "inquiry"}});
                //this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
              }
              
            }); 
          }
          else{
            this.router.navigate(["/description/"+ this.serialOrImeiNumber], { queryParams: {type: "inquiry"}});
            //this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
          }
          
        }); 
       } else if(this.imeiNumber){
         this.serialOrImeiNumber = this.imeiNumber;
         this.assetService.setImei(true);
         this.assetService.getAssetBySerialNumber(this.serialOrImeiNumber).subscribe(data => {
          if(data != null){
            this.router.navigate(["/overview/" + this.serialOrImeiNumber]);
          } else{
            this.router.navigate(["/description/"+ this.serialOrImeiNumber], { queryParams: {type: "inquiry"}});
            //this.router.navigate(["notfound/" + this.serialOrImeiNumber]);
          }
          
        }); 
       }

       
      }
    });  
  }

}
